module.exports = "<!-- Tabla titulos -->\n<div class=\"container\">\n  <div class=\"col-12 dy-table\">\n    <ng2-smart-table [settings]=\"settings\" [source]=\"sourceData\"></ng2-smart-table>\n  </div>\n  <button *ngIf=\"changes\" class=\"btn btn-primary mt-3 ml-2\" (click)=\"saveDocuments()\">Guardar</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/management-automation/manage-documents/manage-documents.component.html
// module id = ./src/app/administration/management-automation/manage-documents/manage-documents.component.html
// module chunks = main